<template>
  <div class="editProfile">
    <adx-sidebar/>
    <div class="editProfile__page container-router">
      <div class="editProfile__page__title">
        <h2 class="medium-title">
          Edit Profile
        </h2>
      </div>
      <div class="editProfile__page__photo">
        <div class="editProfile__page__photo__left">
          <img :src="avatarImage" alt="">
        </div>
        <div class="editProfile__page__photo__right">
          <input type="file" accept="image/*" @change="previewImage"
          ref="fileUpload" style="display: none;">
          <button class="btn-small secondary" @click="launchFilePicker">Change Photo</button>
          <p>Maximum allowed size 2MB</p>
          <p>{{imageName}}</p>
          <p v-if="error.avatar" style="color: red;">{{error.avatar}}</p>
        </div>
      </div>
      <div class="editProfile__form">
        <adx-input :label="`KTP Number`" :value.sync="model.id_number" :error.sync="error.id_number" :validation="['MaxLength:16']"/>
        <adx-input :label="`Full Name`" :value.sync="model.full_name" :error.sync="error.full_name" :validation="['NotEmpty', 'MaxLength:100']"/>
        <adx-input :label="`Email`" :value="model.email" :disabled="true" :button="`Change Email`" @buttonClicked="toggleEmail"/>
        <div class="calendar">
          <v-date-picker
            v-model='singleDate'
            :popoverVisibility="'focus'"
            :theme-styles='themeStyles'
            class='date-input-profile'>
            <div class="field"
              slot-scope='{ inputValue, updateValue }'
            >
              <input
                :readonly="model.birth_date == 'Invalid date' ? false : true"
                class="date-input-profile-input"
                type='text'
                required
                :value='inputValue'
                @input='updateValue($event.target.value, { formatInput: false, hidePopover: false })'
                @change='updateValue($event.target.value, { formatInput: true, hidePopover: false })'>
                <label class="subhead calendar-label">Date of birth</label>
            </div>
          </v-date-picker>
          <p class="color-pink">{{error['birth_date']}}</p>
        </div>
        <adx-input :label="`Phone Number`" :value.sync="model.mobile" :error.sync="error.mobile" :validation="['NotEmpty', 'Phone', 'MaxLength:16']"/>
        <adx-input :label="`NPWP Number`" :value.sync="model.npwp_number" :error.sync="error.npwp_number" :validation="['MaxLength:15', 'Numeric', 'MinLength:15']"/>
        <adx-input :label="`Company Name`" :value.sync="model.company" :error="error.company"/>
        <adx-input :label="`NPWP Name`" :value.sync="model.npwp_name" :error.sync="error.npwp_name" :validation="['MaxLength:50']"/>
        <adx-textarea :label="`Billing Address`" :value.sync="model.address" :error.sync="error.address" :validation="['MaxLength:200']"/>
        <adx-textarea :label="`NPWP Address`" :value.sync="model.npwp_address" :error.sync="error.npwp_address" :validation="['MaxLength:200']"/>
        <adx-input :type="`password`" :label="`Password`" :readonly="true" :button="`Change Password`" @buttonClicked="togglePassword"/>
      </div>
      <button class="btn-large primary" @click="submitData">
        Save
        <div class="loading" v-if="loadingSubmit">
          <adx-loading-secondary  />
        </div>
      </button>
    </div>
    <modal v-if="isOpenEmail" :title="'Change Email'" @modal-close="toggleEmail" :type="`small`">
      <div slot="content" class="content">
        <!-- <div class="content__header">
          <h3 class="small-title title">Change Email</h3>
        </div> -->
        <div class="content__form">
          <adx-input :label="`New Email`" :value.sync="changeEmail.new_email" :error.sync="error.email" :validation="['NotEmpty', 'Email']"/>
          <adx-input :type="`password`" :label="`Password`" :value.sync="changeEmail.password" :error.sync="error.password" :validation="['NotEmpty']"/>
          <button class="btn-small primary" @click="submitChangeEmail">
            Submit
            <div class="loading" v-if="isLoadingChangeEmail">
              <adx-loading-secondary />
            </div>
          </button>
        </div>
      </div>
    </modal>
    <modal v-if="isOpenPassword" :title="'Change Password'" @modal-close="togglePassword" :type="`small`">
      <div slot="content" class="content">
        <!-- <div class="content__header">
          <h3 class="small-title title">Change Password</h3>
        </div> -->
        <div class="content__form">
          <adx-input :type="`password`" :label="`Current Password`" :value.sync="changePassword.current_password" :error.sync="changePasswordError.current_password"/>
          <adx-input :type="`password`" :label="`New Password`" :value.sync="changePassword.new_password" :error.sync="changePasswordError.new_password" :validation="['NotEmpty']"/>
          <adx-input :type="`password`" :label="`Confirm New Password`" :value.sync="changePassword.confirm_password" :error.sync="changePasswordError.confirm_password" :validation="['NotEmpty']"/>
          <button class="btn-small primary" @click="submitChangePassword">
            Submit
            <div class="loading" v-if="isLoadingChangePassword">
              <adx-loading-secondary  />
            </div>
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import SideBar from '@/components/SideBar/Desktop'
import Input from '@/components/Form/Input'
import TextArea from '@/components/Form/TextArea'
import FormAbstraction from '@/components/Form'
import Modal from '@/components/Modal'
import LoadingSecondary from '@/components/Loading/Secondary-white'
import moment from 'moment'

import api from '@/api'
import types from '@/lib/types'
import { sizeConverter } from '@/lib/util'
import { apiV2 } from '@/api/urls'
const {
  ButtonType: { BUTTON, RESET },
  ButtonAction: { SUBMIT, APICALL, GOTO }
} = types

import calendar from 'v-calendar'

export default {
  name: 'adx-edit-profile',
  components: {
    'adx-sidebar': SideBar,
    'adx-input': Input,
    'adx-textarea': TextArea,
    'adx-form': FormAbstraction,
    'modal': Modal,
    'adx-loading-secondary': LoadingSecondary
  },
  watch: {
    singleDate() {
      const date = moment.utc(this.singleDate).local().format('YYYY-MM-DD')
      this.model.birth_date = date
    }
  },
  data() {
    return {
      isLoadingChangeEmail: false,
      isLoadingChangePassword: false,
      loadingSubmit: false,
      singleDate: null,
      themeStyles: {
        dayContent: {
          fontSize: '15px',
        },
        headerTitle: {
          fontSize: '17px',
          fontWeight: 'bold'
        },
        weeks: {
          fontWeight: 'bold'
        },
        wrapper: {
          boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.16)',
          backgroundColor: 'white',
          border: 'none',
        },
        header: {
          marginBottom: '6px'
        },
      },
      model: {
        id: ``,
        id_number: ``,
        full_name: ``,
        email: ``,
        birth_date: ``,
        mobile: ``,
        npwp_name: ``,
        npwp_number: ``,
        npwp_address: ``,
        company: ``,
        address: ``
      },
      wrapper: {
        alertWrapper: `content`
      },
      onSubmit: {
        wrapper: {
          class: ``
        },
        buttons: [
          {
            type: BUTTON,
            action: SUBMIT,
            label: `Save`,
            uri: apiV2.xxx, // TBD
            params: this.model,
            method: `post`,
            class: `btn-regular primary`,
            isLoading: false
          },
        ]
      },
      schema: [
        {
          type: 'inline',
          fields: [
            {
              type: 'input',
              inputType: 'number',
              label: 'KTP Number',
              model: 'idnumber',
              method: 'onChange',
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'Full Name',
              model: 'fullname',
              method: 'onChange',
              validation: ['NotEmpty', 'MaxLength:100'],
            }
          ]
        },
        {
          type: 'inline',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Email Address',
              model: 'email',
              method: 'onChange',
              validation: ['NotEmpty', 'Email'],
            },
            {
              type: 'input',
              inputType: 'date',
              label: 'Birth Date',
              model: 'birth',
              method: 'onChange',
              validation: ['NotEmpty'],
            }
          ]
        },
        {
          type: 'inline',
          fields: [
            {
              type: 'input',
              inputType: 'number',
              label: 'Phone Number',
              model: 'mobile',
              method: 'onChange',
              validation: ['NotEmpty', 'Phone', 'MaxLength:16']
            },
            {
              type: 'input',
              inputType: 'number',
              label: 'NPWP Number',
              model: 'npwpnumber',
              method: 'onChange',
            }
          ]
        },
        {
          type: 'inline',
          fields: [
            {
              type: 'input',
              inputType: 'text',
              label: 'Company Name',
              model: 'company',
              method: 'onChange',
            },
            {
              type: 'input',
              inputType: 'text',
              label: 'NPWP Name',
              model: 'npwpname',
              method: 'onChange',
            }
          ]
        },
        {
          type: 'inline',
          fields: [
            {
              type: 'textarea',
              inputType: 'text',
              label: 'Billing Address',
              model: 'address',
              method: 'onChange',
              validation: ['MaxLength:200']
            },
            {
              type: 'textarea',
              inputType: 'text',
              label: 'NPWP Address',
              model: 'npwpaddress',
              method: 'onChange',
              validation: ['MaxLength:200']
            }
          ]
        },
        {
          type: 'block',
          fields: [
            {
              type: 'input',
              inputType: 'password',
              label: 'Password',
              model: 'password',
              method: 'onChange',
              validation: ['NotEmpty']
            }
          ]
        },
      ],
      error: {
        id: ``,
        id_number: ``,
        full_name: ``,
        email: ``,
        birth_date: ``,
        mobile: ``,
        npwp_name: ``,
        npwp_number: ``,
        npwp_address: ``,
        company: ``,
        address: ``,
        avatar: ``,
        password: ``
      },
      changeEmail: {
        current_email: ``,
        new_email: ``,
        password: ``
      },
      changePassword: {
        current_password: ``,
        new_password: ``,
        confirm_password: ``
      },
      changePasswordError: {
        current_password: ``,
        new_password: ``,
        confirm_password: ``
      },
      avatarImage: "/img/account/img-ava.png",
      imageName: null,
      imageData: null,
      isOpenEmail: false,
      isOpenPassword: false,
      pass: ``
    }
  },
  created() {
    this.loadData()
  },
  mounted() {
    const { status, message } = this.$route.query
    if (status && message) {
      this.$notify({
        group: 'saved',
        title: status,
        text: message,
        type: 'success'
      });
    }
  },
  methods: {
    loadData() {
      (async () => {
        const { data } = await api.get(apiV2.userProfile, { needToken: true })
        if (data) {
          this.avatarImage = data.avatar ? data.avatar : this.avatarImage
          this.changeEmail['current_email'] = data.email
          this.singleDate = new Date(moment.utc(data.birth_date))
          Object.keys(data).map(el => {
            this.model[el] = data[el]
          })
        }
      })();
    },
    previewImage(event) {
      let input = event.target;
      if (input.files && input.files[0]) {
        let reader = new FileReader();
        let validated_data = this.validateFile(input.files[0])
        if (!validated_data.is_valid) {
          this.error['avatar'] = validated_data.message
        } else {
          reader.onload = (e) => {
            this.avatarImage = e.target.result;
          }
          reader.readAsDataURL(input.files[0]);
          this.imageName = input.files[0].name;
          this.imageData = input.files[0];
        }
      }
    },
    validateFile(file) {
      let maxSize = 2000000; // 2 MB
      let data = { is_valid: true }
      if (/image/.test(file.type)) {
        let image_ext_patt = new RegExp(/.jpg|.jpeg|.png/)
        if (!image_ext_patt.test(file.name.toLowerCase())) {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
        }
      } else {
          data.is_valid = false
          data.message = 'Unsupported file type'
          return data
      }
      if (file.size > maxSize) {
        data.is_valid = false
        data.message = `File too large.`
        return data
      }
      const filename = file.name.split('.')[0]
      if (filename.length > 100) {
        data.is_valid = false
        data.message = 'File name is too long. Maximum size 100 character'
        return data
      }

      if (filename.includes('/')) {
        data.is_valid = false
        data.message = 'File name has forbidden character'
        return data
      }
      return data
    },
    launchFilePicker(){
      this.$refs.fileUpload.click();
    },
    toggleEmail() {
      this.isOpenEmail = !this.isOpenEmail
    },
    togglePassword() {
      this.isOpenPassword = !this.isOpenPassword
    },
    submitData(){
      (async () => {
        this.loadingSubmit = true
        if(this.model.birth_date == 'Invalid date') this.model.birth_date = ''
        var data = new FormData();
        if(this.imageData){
          data.append('avatar', this.imageData)
        }
        Object.keys(this.model).map( key => {
          if(this.model[key] !== null && key != 'avatar') data.append(key, this.model[key])
        })
        const response = await api.put(apiV2.userProfile, data, { needToken: true })
        if (response.status === 200) {
          this.$notify({
            group: 'saved',
            title: `success`,
            text: `edit profile success`,
            type: 'success'
          })
          await this.$store.dispatch(`setProfile`, response)
        } else {
          const { first_name, last_name, birth_date } = response.data
          Object.keys(response.data).map(el => {
            this.error[el] = response.data[el].pop()
          })
          if (first_name || last_name) {
            this.error['full_name'] = `Please ensure your name not exceed 100 character`
          }else if(birth_date) {
            this.error['birth_date'] = `Date has wrong format. Use one of these formats instead: YYYY[-MM[-DD]].`
          }
        }
        this.loadingSubmit = false
      })();
    },
    submitChangeEmail () {
      (async () => {
        this.isLoadingChangeEmail = true
        const body = this.changeEmail
        const response = await api.post(apiV2.changeEmail, body, { needToken: true })
        if (response.status === 200) {
          this.toggleEmail()
          this.$notify({
            group: 'saved',
            title: `success`,
            text: response.data.message,
            type: 'success'
          })
        } else {
          const { new_email, password } = response.data
          if (new_email) this.error.email = new_email
          if (password) this.error.password = password
        }
        this.isLoadingChangeEmail = false
      })();
    },
    submitChangePassword () {
      (async () => {
        this.isLoadingChangePassword = true
        const body = this.changePassword
        const response = await api.post(apiV2.changePassword, body, { needToken: true })
        if (response.status === 200) {
          this.togglePassword()
          this.$notify({
            group: 'saved',
            title: `success`,
            text: `change password success`,
            type: 'success'
          })
        } else {
          this.changePasswordError = response.data
        }
        this.isLoadingChangePassword = false
      })();
    }
  }
}
</script>

<style lang="scss" scoped>
@import './index.scss';
</style>

<style lang="scss">
.editProfile {
  .form {
    form .form-block {
      width: 50%;
    }
  }
}
</style>
